module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.6fdf8c2e.mp3";